module.exports = __webpack_public_path__ + "assets/img/part3.4519518f.png";